export class GenericSnapshotData {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "startedAt",
            "baseName": "startedAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "snapshotLocation",
            "baseName": "snapshotLocation",
            "type": "SnapshotLocation",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GenericSnapshotData.attributeTypeMap;
    }
    constructor() {
    }
}
